import translations from './translations.json'; // Assuming translations are stored in a JSON file

function t(key) {
  return translations[key] || key;
}

export { t };